// extracted by css-extract-rspack-plugin
export default {"curvy-arrow":"P5tYxYn___curvy-arrow","curvyArrow":"P5tYxYn___curvy-arrow","active":"_1i5YNx___active"};